import { useSyncExternalStore } from 'react';

/**
 * Whether the device has a network at all, read from the browser — no request
 * is sent to find out. The browser flips `navigator.onLine` and fires
 * `online` / `offline` the moment Wi-Fi or mobile data drops or returns.
 *
 * `false` is reliable: there is no connection. `true` only means there is a
 * network, not that it reaches the internet (a hotel Wi-Fi before its login
 * page, say), so a request can still fail with `FETCH_ERROR` while this reads
 * online — pages keep handling that case themselves.
 */
export const isOffline = () => typeof navigator !== 'undefined' && navigator.onLine === false;

const subscribe = (onChange) => {
  window.addEventListener('online', onChange);
  window.addEventListener('offline', onChange);
  return () => {
    window.removeEventListener('online', onChange);
    window.removeEventListener('offline', onChange);
  };
};

/** `true` while the device has a network; re-renders when that changes. */
export const useOnline = () => useSyncExternalStore(subscribe, () => !isOffline(), () => true);
